export const GET_STARTED_COOKIE_NAME = 'getStartedForm' as string;
export const TEAMLOCKER_COOKIE_NAME = '_squad-locker_session' as string;
// Shared OAuth token cookie, set by the SquadLocker Rails API on login (POST /oauth/token)
// and cleared on logout (DELETE /session). This app only reads it — the server owns it.
// The name is environment-specific (QA uses `qa_sqd_oauth_token`), so it comes from
// PUBLIC_OAUTH_COOKIE_NAME at build time and must match what the API sets.
// Read from import.meta.env directly rather than via api/auth/config.ts: that module
// imports oauthToken.ts, which imports this file, so routing through it would cycle.
export const OAUTH_TOKEN_NAME = (import.meta.env.PUBLIC_OAUTH_COOKIE_NAME || 'sqd_oauth_token') as string;

export const LOGO_UPLOADED_BY_STOREBUILDER_PREFIX = 'storebuilder/';

export const BACKGROUND_REMOVED_IMAGE_PREFIX = 'background-removed-';
// Shared OAuth token cookie, set by the SquadLocker Rails API on login (POST /oauth/token)
// and cleared on logout (DELETE /session). This app only reads it — the server owns it.
// Set on landing (SignupLayout) whenever `utm_variant` equals FAN_FAVORITES_UTM_VARIANT_VALUE,
// independent of LaunchDarkly. Gates whether we even consult the `storebuilderFanFavorites`
// flag, so that check no longer relies solely on LD's own targeting rule for `utm_variant` to
// stay off by default. Persisted (rather than re-read from the URL) because navigation between
// signup steps, and the redirect into the builder, doesn't forward search params.
export const UTM_VARIANT_COOKIE_NAME = 'utm_variant_present' as string;
// The exact `utm_variant` value that opts a signup into the fan favorites experience — any other
// value (or its absence) leaves fan favorites off.
export const FAN_FAVORITES_UTM_VARIANT_VALUE = 'showFanFavorites' as string;

export const BUILD_STATUS_COMPLETE = 100 as number;
